module.exports = __webpack_public_path__ + "img/big.e4630fa0.jpg";